// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"6502679c","378":"b8ae4e06","596":"bcc96b83"}[chunkId] + ".chunk.css";
};